module.exports = __webpack_public_path__ + "static/media/others.2b716e50.svg";